import { ExcludeType } from "@/services/api/moreFeatures/pickList";

const PickListExcludeTypeNameMap = {
    [ExcludeType.EXCLUDE_WAYBILL_NO_PRINTED]: "排除已打印快递单的订单",
    [ExcludeType.EXCLUDE_UNDELIVERABLE_AREA]: "排除不可达订单",
    [ExcludeType.EXCLUDE_PACK_LIST_PRINTED]: "排除已打印发货单的订单",
    [ExcludeType.EXCLUDE_REFUNDING_PRINTED]: "排除退款中的订单(排除退款中订单全部商品)",
    [ExcludeType.EXCLUDE_REFUNDING_ORDER_ITEM]: "排除退款中的订单(仅排除退款中商品)",
    [ExcludeType.EXCLUDE_ON_HOLD_PRINTED]: "排除挂起的订单",
    [ExcludeType.EXCLUDE_PRE_SHIPPING]: "排除预发货的订单",
};

export default PickListExcludeTypeNameMap;
